import { render, staticRenderFns } from "./home.html?vue&type=template&id=22b2a41a&scoped=true&external"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=22b2a41a&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=22b2a41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2a41a",
  null
  
)

export default component.exports